/** Edit mode format */
export const DATE_FORMAT = 'L';
export const EDIT_TIME_FORMAT = 'HH:mm';
export const EDIT_DATE_TIME_FORMAT = `${DATE_FORMAT} ${EDIT_TIME_FORMAT}`;

/** Read mode format */
export const READ_DATE_TIME_FORMAT = `${DATE_FORMAT} [at] h:mma`;
